<template>
  <v-container>
    <v-card>
      <v-card-text>
        ケア用品一覧<br>

        <v-list
          two-line
          style="margin-bottom: 100px"
        >
          <v-list-item
            v-for="item in sortedItems"
            :key="item.id"
            class="mt-4 align-start list-item-with-border"
          >
            <!-- 商品画像：クリックでダイアログ表示 --><v-list-item-avatar
                                        tile
                                        size="160"
                                      >
                                        <v-img
                                          :src="item.image || fallbackImage"
                                          class="clickable-image"
                                          @click="openImage(item.image)"
                                        >
                                          <!-- 🔍 虫眼鏡アイコンを画像の上に重ねる -->
                                          <template #placeholder>
                                            <!-- 画像ロード中のプレースホルダ（任意） -->
                                          </template>
                                          <v-icon
                                            v-if="item.image"
                                            class="zoom-icon"
                                            color="white"
                                            small
                                          >
                                            mdi-magnify
                                          </v-icon>
                                        </v-img>
                                      </v-list-item-avatar>

            <!-- 拡大画像ダイアログ（image_dialog を使う） -->
            <v-dialog
              v-if="image_dialog"
              v-model="image_dialog"
              max-width="600px"
            >
              <v-card>
                <v-img
                  :src="selectedImage || fallbackImage"
                  contain
                  @error="selectedImage = fallbackImage"
                />
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    text
                    @click="image_dialog = false"
                  >
                    閉じる
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-list-item-content>
              <v-list-item-title class="multi-line-title no-ellipsis">
                {{ item.price_normal_name }}
              </v-list-item-title>

              <v-list-item-title class="multi-line-body">
                <div :class="{ collapsed: !expandedMap[item.id] }">
                  {{ item.clios_item_note }}
                </div>
                <v-btn
                  text
                  x-small
                  @click.stop="toggleExpanded(item.id)"
                >
                  {{ expandedMap[item.id] ? "閉じる" : "続きを読む" }}
                </v-btn>
              </v-list-item-title>

              <v-list-item-subtitle>
                <template v-if="getFormattedPrice(item).hasSale">
                  <span class="red--text font-weight-bold">
                    {{ getFormattedPrice(item).salePrice }}円（税込）
                  </span>
                  <span class="grey--text text--line-through ml-2">
                    {{ getFormattedPrice(item).normalPrice }}円
                  </span>
                </template>
                <template v-else>
                  {{ getFormattedPrice(item).normalPrice }}円（税込）
                </template>
              </v-list-item-subtitle>
              <!-- 購入数コントロール -->
              <div class="mt-2 d-flex align-center">
                <v-btn
                  icon
                  outlined
                  small
                  @click="decreaseQuantity(item)"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
                <span class="mx-2">{{ item.quantity }}</span>
                <v-btn
                  icon
                  outlined
                  small
                  @click="increaseQuantity(item)"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
    </v-card>
    <v-card
      class="selected-items-card"
      outlined
    >
      <v-card-text>
        <div v-if="Object.keys(selectedItems).length">
          <ul>
            <li
              v-for="(qty, id) in selectedItems"
              :key="id"
            >
              {{ getItemNameById(id) }}：{{ qty }} 個
            </li>
          </ul>
          <span v-if="carriage != 0">
            {{ $t("発送料") }}:{{ carriage.toLocaleString() }}
            {{ $t("円") }}
          </span>
          <span v-if="carriage == 0">
            {{ $t("送料無料") }}
          </span>
          <h3>
            {{ $t("合計") }}:{{ Math.round(total).toLocaleString()
            }}{{ $t("円（税込）") }}
          </h3>
          <h3
            v-if="coupon.is_active"
            class="red--text text--lighten-1 ma-5"
          >
            <span v-if="coupon.type == '%'">
              {{ discount.toLocaleString() }}{{ $t("円割引") }}
              {{ coupon.value }}%OFF
            </span>
            <span v-if="coupon.type == '円'">
              {{ coupon.value }}{{ $t("割引クーポン適用中") }}
            </span>
          </h3>
          <div class="mt-5">
            <v-btn
              small
              color="success"
              @click="checkout"
            >
              購入へ
            </v-btn>
            <v-btn
              class="ml-5"
              small
              color="error"
              @click="clearSelectedItems"
            >
              削除
            </v-btn>
          </div>
        </div>
        <div v-else>
          選択中の商品はありません。
        </div>
      </v-card-text>
    </v-card>
    <v-btn
      class="mt-5"
      color="primary"
      dark
      @click="goBack"
    >
      戻る
    </v-btn>
  </v-container>
</template>

<script>
import { Firebase } from "@/config/firebase";
import { isCareItem, normalizeCareItem } from "@/utils/careItems";
import "firebase/storage";

export default {
  name: "CareItems",
  data() {
    return {
      items: [],
      shippingFee: 770,
      freeShippingThreshold: 6000,
      selectedItems: {}, // ← 選択した { item.id: quantity } を保持
      expandedMap: {}, //複数アイテムで展開状態を管理
      image_dialog: false,
      dialog: false,
      selectedImage: "",
      sub_total: {
        totalQuantity: 0,
        totalAmount: 0,
      },
      is_able: { is_able: true },
      is_coupon: false,

      couponBucketId: "",
      coupon: {
        id: null,
        code: "",
        clinic_id: "",
        saler_id: "",
        staff_id: "",
        staffs: [],
        clinic_name: "",
        shop_name: "",
        staff_name: "",
        coupon_name: "",
        value: 0,
        type: "rate",
        is_active: false,
        is_unlimit: false,
        is_once: true,
      },
      coupon_code: "",
      is_coupon_loader: false,
      cart_button_disabled: false,
      fallbackImage: "/images/noimages.png",
      user_history_count: 100, // 初期値（購入履歴なし＝0にすれば割引有効）
      patient_id: "",
      patient: null,
      prescription: undefined,
      order: {
        user_id: null,
        email: null,
        user: null,
        cellnumber: null,
        priscription_id: null,
        priscription: null,
        status: "draft",
      },
    };
  },
  computed: {
    clinic_id() {
      return this.$route.params.id;
    },
    user_id() {
      return this.$store.getters.user.uid;
    },
    firstcouponFlag() {
      return (
        this.clinic &&
        this.clinic.is_firstcoupon === true &&
        this.user_history_count === 0
      );
    },

    patientNumber() {
      return this.patient.patientNumber;
    },
    saler_name() {
      return this.clinic.saler_name;
    },
    commission() {
      return this.clinic.commission;
    },
    firstcoupon_flag() {
      if (this.clinic.is_firstcoupon) {
        //購入履歴をチェック
        if (this.user_history_count == 0) {
          const r_price =
            Number(this.r_manufacture.price_normal_price) -
            Number(this.r_manufacture.price_normal_sale_price);
          const l_price =
            Number(this.l_manufacture.price_normal_price) -
            Number(this.l_manufacture.price_normal_sale_price);
          if (r_price > 0 || l_price > 0) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    carriage() {
      const amount = Number(this.sub_total.totalAmount) || 0;

      if (amount === 0) return 0; // 商品なし
      if (amount >= this.freeShippingThreshold) return 0; // 6,000円以上は無料
      return this.shippingFee; // それ以外は一律770円
    },
    total() {
      if (this.coupon) {
        if (this.coupon.type == "円") {
          return this.sub_total.totalAmount + this.carriage - this.coupon.value;
        } else if (this.coupon.type == "%") {
          return this.sub_total.totalAmount + this.carriage - this.discount;
        }
      }
      return this.sub_total.totalAmount + this.carriage;
    },
    discount() {
      let temp_disscount = 0;
      if (this.coupon.type == "%") {
        temp_disscount =
          ((this.sub_total.totalAmount + this.carriage) * this.coupon.value) /
          100;
      } else if (this.coupon.type == "円") {
        temp_disscount =
          this.sub_total.totalAmount + this.carriage - this.coupon.value;
      }
      return Math.floor(temp_disscount);
    },
    sortedItems() {
      return [...this.items].sort((a, b) => {
        const priceDifference =
          Number(b.price_normal_price) - Number(a.price_normal_price);

        if (priceDifference !== 0) return priceDifference;
        return Number(a.order || 0) - Number(b.order || 0);
      });
    },
  },
  watch: {
    coupon_code: async function () {
      if (!this.coupon_code) {
        this.is_coupon = false;
        this.coupon = {
          code: "",
          clinic_id: "",
          saler_id: "",
          staff_id: "",
          staffs: [],
          clinic_name: "",
          shop_name: "",
          staff_name: "",
          coupon_name: "",
          value: 0,
          type: "",
          is_active: false,
          is_unlimit: false,
          is_once: true,
        };
      } else {
        try {
          if (this.coupon_code.length > 3) {
            try {
              await Firebase.firestore()
                .collection("Coupons")
                .where("code", "==", this.coupon_code)
                .where("clinic_id", "==", this.clinic.id)
                .where("is_active", "==", true)
                .limit(1)
                .get()
                .then((querySnapshot) => {
                  if (querySnapshot.empty) {
                    alert("クーポンが見つかりません");
                    this.is_coupon = false;
                    this.coupon = {
                      code: "",
                      clinic_id: "",
                      saler_id: "",
                      staff_id: "",
                      staffs: [],
                      clinic_name: "",
                      shop_name: "",
                      staff_name: "",
                      coupon_name: "",
                      value: 0,
                      type: "rate",
                      is_active: false,
                      is_unlimit: false,
                      is_once: true,
                    };
                  } else {
                    if (!querySnapshot.empty) {
                      querySnapshot.forEach((doc) => {
                        this.coupon = doc.data();
                        this.coupon.id = doc.id;
                        this.is_coupon = true;
                      });
                    }
                  }
                })
                .catch(() => {
                  this.coupon = {
                    code: "",
                    clinic_id: "",
                    saler_id: "",
                    staff_id: "",
                    staffs: [],
                    clinic_name: "",
                    shop_name: "",
                    staff_name: "",
                    coupon_name: "",
                    value: 0,
                    type: "",
                    is_active: false,
                    is_unlimit: false,
                    is_once: true,
                  };
                  this.is_coupon = false;
                });
              if (
                this.coupon.is_active != false &&
                this.coupon.is_unlimit != true
              ) {
                await Firebase.firestore()
                  .collection("CouponBuckets")
                  .where("coupon_id", "==", this.coupon.id)
                  .where("user_id", "==", this.user.id)
                  .where("is_active", "==", true)
                  .get()
                  .then((querySnapshot) => {
                    if (!querySnapshot.empty) {
                      if (querySnapshot.size >= this.coupon.limit) {
                        alert(
                          "クーポンが" +
                            querySnapshot.size +
                            "回使用されています。このクーポンは" +
                            this.coupon.limit +
                            "回まで利用可能です。"
                        );
                        this.is_coupon = false;
                        this.coupon = {
                          code: "",
                          clinic_id: "",
                          saler_id: "",
                          staff_id: "",
                          staffs: [],
                          clinic_name: "",
                          shop_name: "",
                          staff_name: "",
                          coupon_name: "",
                          value: 0,
                          limit: 0,
                          type: "rate",
                          is_active: false,
                          is_unlimit: false,
                          is_once: true,
                        };
                      }
                    } else {
                      this.is_coupon = true;
                    }
                  });
              }
            } catch (e) {
              if (this.error == true) {
                this.coupon = {
                  code: "",
                  clinic_id: "",
                  saler_id: "",
                  staff_id: "",
                  staffs: [],
                  clinic_name: "",
                  shop_name: "",
                  staff_name: "",
                  coupon_name: "",
                  value: 0,
                  type: "",
                  is_active: false,
                  is_unlimit: false,
                  is_once: true,
                };
                this.is_coupon = false;
              } else {
                this.coupon = {
                  code: "",
                  clinic_id: "",
                  saler_id: "",
                  staff_id: "",
                  staffs: [],
                  clinic_name: "",
                  shop_name: "",
                  staff_name: "",
                  coupon_name: "",
                  value: 0,
                  type: "",
                  is_active: false,
                  is_unlimit: false,
                  is_once: true,
                };
                this.is_coupon = false;
              }
            } finally {
              //this.loading = false;
            }
          } else {
            this.coupon = {
              code: "",
              clinic_id: "",
              saler_id: "",
              staff_id: "",
              staffs: [],
              clinic_name: "",
              shop_name: "",
              staff_name: "",
              coupon_name: "",
              value: 0,
              type: "",
              is_active: false,
              is_unlimit: false,
              is_once: true,
            };
            this.is_coupon = false;
          }
        } catch (e) {
          console.log("clios_check is unable ", e);
        }
      }
    },
  },
  async created() {
    await this.fetchClinic();
    await this.fetchUsers();
    await this.fetchPatient();
    await this.fetchSeller(this.clinic.saler_id);
    await this.fetchCareItems();
    await this.fetchItemsWithStorageImage();
    this.check_first;
  },
  methods: {
    fetchClinic: async function () {
      try {
        const clinicRef = await Firebase.firestore()
          .collection("Clinics")
          .doc(this.clinic_id);
        await clinicRef.get().then((doc) => {
          if (doc.exists) {
            this.clinic = doc.data();
            this.clinic.id = doc.id;
          } else {
            console.log("No clinic document!");
          }
          this.error = true;
        });
      } catch (e) {
        if (this.error == true) {
          this.$router.push({
            name: "error",
            params: { message: "表示できません。" },
          });
        } else {
          console.error("fetchClinic ", e);
        }
      } finally {
        //this.loading = false
      }
    },
    fetchSeller: async function (saler_id) {
      const sellerRef = await Firebase.firestore()
        .collection("Sellers")
        .doc(saler_id);
      await sellerRef.get().then((doc) => {
        if (doc.exists) {
          this.seller = doc.data();
          this.seller.id = doc.id;
          this.makers = this.seller.makers;
        } else {
          console.log("No seller document!");
        }
        this.error = true;
      });
    },
    fetchUsers: async function () {
      const userRef = await Firebase.firestore()
        .collection("Users")
        .doc(this.user_id);
      await userRef.get().then((doc) => {
        if (doc.exists) {
          this.user = doc.data();
          this.user.id = doc.id;
          let clinics = this.user.clinics;
          if (clinics.length > 0) {
            for (const clinic of clinics) {
              if (clinic.clinic_id === this.clinic_id) {
                this.patient_id = clinic.patient_id;
                break;
              }
            }
          }
        } else {
          console.log("No user document!");
        }
        this.error = true;
      });
      this.fetchPatient();
    },
    fetchPatient: async function () {
      if (this.patient_id != null) {
        const patientRef = Firebase.firestore()
          .collection("Patients")
          .doc(this.patient_id);
        const doc = await patientRef.get();
        if (!doc.exists) {
          console.log("No such Patients document!");
        } else {
          this.patient = doc.data();
          this.patient.id = doc.id;
        }
      } else {
        this.$router.push({
          name: "error",
          params: { message: "表示できません。" },
        });
      }
    },
    check_first: async function () {
      this.user_history_count = 100;
      try {
        await Firebase.firestore()
          .collection("Orders")
          .where("clinic_id", "==", this.prescription.clinic_id)
          .where("patientNumber", "==", this.prescription.patient_patientNumber)
          .where("status", "in", ["paied", "paid", "send", "cancel", "done"])
          .get()
          .then((querySnapshot) => {
            if (querySnapshot.empty) {
              this.user_history_count = 0;
            } else {
              this.user_history_count = 100;
            }
          })
          .catch((error) => {
            this.user_history_count = 100;
            console.log("Error getting Orders check_first:", error);
          });
      } catch (e) {
        this.user_history_count = 100;
        console.log("Error getting Orders check_first:", e);
      }
    },
    async fetchCareItems() {
      const db = Firebase.firestore();
      const snapshot = await db
        .collection("Manufactures")
        .where("clinic_id", "==", this.clinic_id)
        .get();

      snapshot.forEach((doc) => {
        const rawData = doc.data();
        if (!isCareItem(rawData)) return;

        const data = normalizeCareItem(rawData);
        data.id = doc.id;
        data.quantity = 0;
        this.items.push(data);
      });
    },
    async fetchItemsWithStorageImage() {
      const db = Firebase.firestore();
      let tempItems = [];
      for (let i = 0; this.items.length > i; i++) {
        const data = this.items[i];
        const priceCode = Number(data.price_code);

        // 🔍 price_code で Clioses から画像パスを取得
        const productSnap = await db
          .collection("Products")
          .where("clios_item_code", "==", priceCode)
          .limit(1)
          .get();

        if (!productSnap.empty) {
          const ProductDoc = productSnap.docs[0];
          const productData = ProductDoc.data();
          data.clios_item_note = productData.clios_item_note;
          // ✅ image が Storage パス形式なら URL に変換
          if (productData.imageUrl) {
            try {
              const imageUrl = await Firebase.storage()
                .ref(productData.imageUrl)
                .getDownloadURL();
              data.image = imageUrl;
            } catch (e) {
              console.warn("画像の取得に失敗しました", e);
              data.image = this.fallbackImage;
            }
          } else {
            data.image = this.fallbackImage;
          }
        } else {
          data.image = this.fallbackImage;
          data.clios_item_note = "";
        }
        tempItems.push(data);
      }
      this.items = tempItems;
    },
    getFormattedPrice(item) {
      const normal = Number(item.price_normal_price).toLocaleString();
      const sale = item.price_normal_sale_price
        ? Number(item.price_normal_sale_price).toLocaleString()
        : null;

      if (this.firstcouponFlag && sale) {
        return {
          hasSale: true,
          salePrice: sale,
          normalPrice: normal,
        };
      } else {
        return {
          hasSale: false,
          normalPrice: normal,
        };
      }
    },
    increaseQuantity(item) {
      item.quantity++;
      this.$set(this.selectedItems, item.id, item.quantity);
      this.updateSubTotal(); // ← 合計更新
    },
    decreaseQuantity(item) {
      if (item.quantity > 0) {
        item.quantity--;
        if (item.quantity === 0) {
          this.$delete(this.selectedItems, item.id);
        } else {
          this.$set(this.selectedItems, item.id, item.quantity);
        }
        this.updateSubTotal(); // ← 合計更新
      }
    },
    clearSelectedItems() {
      this.items.forEach((item) => {
        item.quantity = 0;
      });
      this.selectedItems = {};
      this.updateSubTotal(); // ← 合計リセット
    },
    openImage(image) {
      console.log("Click");
      this.selectedImage = image || this.fallbackImage;

      // 画像URLをセット後にダイアログを開く
      this.$nextTick(() => {
        this.image_dialog = true;
      });
    },
    getItemNameById(id) {
      const item = this.items.find((i) => i.id === id);
      return item ? item.price_normal_name : "不明な商品";
    },
    toggleExpanded(id) {
      this.$set(this.expandedMap, id, !this.expandedMap[id]);
    },
    // カートの合計管理
    updateSubTotal() {
      let totalQty = 0;
      let totalAmt = 0;

      for (const [id, qty] of Object.entries(this.selectedItems)) {
        const item = this.items.find((i) => i.id === id);
        if (item) {
          const price =
            this.firstcouponFlag && item.price_normal_sale_price
              ? Number(item.price_normal_sale_price)
              : Number(item.price_normal_price);
          totalQty += qty;
          totalAmt += price * qty;
        }
      }

      this.sub_total.totalQuantity = totalQty;
      this.sub_total.totalAmount = totalAmt;
    },
    // 支払い画面へ移動
    checkout: async function () {
      await this.create_order();
      this.$router.push({
        name: "checkout_careitem",
        params: {
          id: this.order.id,
        },
        query: {
          patient_id: this.patient_id,
          clinic_id: this.clinic.id,
        },
      });
    },

    create_order: async function () {
      let care_items = [];

      Object.keys(this.selectedItems).forEach((selectedId) => {
        const matchedItem = this.items.find((item) => item.id === selectedId);
        if (matchedItem) {
          if (this.getFormattedPrice(matchedItem).hasSale) {
            matchedItem.price = this.getFormattedPrice(matchedItem).salePrice;
          } else {
            matchedItem.price = this.getFormattedPrice(matchedItem).normalPrice;
          }
          const quantity = this.selectedItems[selectedId];
          matchedItem.quantity = quantity;
          care_items.push(matchedItem);
        }
      });

      this.order = {
        user_id: this.user.id,
        email: this.user.email,
        user: this.user,
        cellnumber: this.user.phone,
        care_items: care_items,
        status: "draft",
      };
      this.order.patient_id = this.patient.id;
      this.order.patient_name = this.patient.name;
      this.order.patientNumber = this.patient.patientNumber;
      this.order.patient_cardNumber = this.patient.patientNumber;
      this.order.clinic_id = this.clinic_id;
      this.order.clinic_name = this.patient.clinic_name;

      this.order.discount = this.discount;
      this.order.is_coupon = this.is_coupon;
      if (this.is_coupon === true) {
        this.order.coupon = this.coupon;
        this.order.coupon.applied = this.discount;
      }

      this.order.toral_price = this.total;
      this.order.saler_name = this.clinic.saler_name;
      this.order.saler_id = this.clinic.saler_id;
      this.order.saler_email = this.clinic.saler_email;

      this.order.delivery_fee = this.carriage;
      this.order.created_at = new Date();
      this.order.is_firstcoupon = this.firstcoupon_flag;
      this.loading = true;

      let orderRef = await Firebase.firestore()
        .collection("Orders")
        .add(this.order);
      this.order.id = orderRef.id;
    },
    goBack() {
      this.$router.push("/priscription_list/" + this.clinic_id);
    },
  },
};
</script>

<style scoped>
.selected-items-card {
  position: fixed;
  bottom: 20px;
  right: 20px;
  width: 220px;
  max-height: 60vh;
  overflow-y: auto;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}
.list-item-with-border {
  border-bottom: 1px solid #e0e0e0;
}
.thumbnail-wrapper {
  position: relative;
  cursor: pointer;
}

.thumbnail-image {
  width: 100%;
  height: 100%;
}

.zoom-icon {
  position: absolute;
  bottom: 4px;
  right: 4px;
  background-color: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  padding: 4px;
  transition: opacity 0.3s;
  opacity: 0;
}

.thumbnail-wrapper:hover .zoom-icon {
  opacity: 1;
}

.multi-line-body {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  display: block;
  word-break: break-word;
}

.multi-line-body {
  position: relative;
  max-width: 100%;
  font-size: 14px;
  line-height: 1.4;
}

.multi-line-title {
  position: relative;
  max-width: 100%;
  font-size: 14px;
  line-height: 1.4;
}

.collapsed {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.no-ellipsis {
  white-space: normal !important;
  overflow: visible !important;
  text-overflow: unset !important;
  display: block !important;
  word-break: break-word;
}
</style>
